// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface ICalibrationReport {
	id: string | undefined;

	deviceId: string | undefined;

	createdUtc: string;

	passed: boolean;

	chamberId: string | undefined;

	serialNumber: string | undefined;

	firmwareVersion: string | undefined;

	radarFirmwareVersion: string | undefined;

	calibrationConfig: string | undefined;

	reportVersion: number;

	limitsVersion: number;

	failureReason: string | undefined;

	radarPassed: boolean | undefined;

	accelerometerPassed: boolean | undefined;

	fieldOfViewPassed: boolean | undefined;

	rangeBiasMeters: number | undefined;

	channelImbalance: number | undefined;

	peakSnrDb: number | undefined;

	predictedMaxRangeMeters: number | undefined;

	deadCellCount: number | undefined;

	report: string | undefined;

	$type?: string | undefined;
}
export class CalibrationReport {
	constructor(data?: ICalibrationReport) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.createdUtc = new Date(data.createdUtc);
	}

	id: string | undefined;

	deviceId: string | undefined;

	@IsNotEmpty()
	createdUtc: Date = new Date();

	passed: boolean = false;

	chamberId: string | undefined;

	serialNumber: string | undefined;

	firmwareVersion: string | undefined;

	radarFirmwareVersion: string | undefined;

	calibrationConfig: string | undefined;

	reportVersion: number = 0;

	limitsVersion: number = 0;

	failureReason: string | undefined;

	radarPassed: boolean | undefined;

	accelerometerPassed: boolean | undefined;

	fieldOfViewPassed: boolean | undefined;

	rangeBiasMeters: number | undefined;

	channelImbalance: number | undefined;

	peakSnrDb: number | undefined;

	predictedMaxRangeMeters: number | undefined;

	deadCellCount: number | undefined;

	report: string | undefined;

	static $type: string = "CoreApi.Models.CalibrationReport, ";
	$type?: string | undefined = CalibrationReport.$type;
}

